/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { isEmpty } from 'lodash';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { setNotification } from 'utils';
import {
    loadPartnersRes,
    loadPartnersErr,
    addNewPartnerRes,
    addNewPartnerErr,
    loadEditablePartnerRes,
    editPartnerRes,
    editPartnerErr,
} from '../actions/partnerActions';
import {
    getPartnersApi,
    addNewPartnerApi,
    editPartnerApi,
    addNewPartnerHolidaysApi,
    editPartnerHolidaysApi,
} from '../api/partnerApi';
import {
    LOAD_PARTNERS,
    ADD_NEW_PARTNER,
    LOAD_EDITABLE_PARTNER,
    EDIT_PARTNER,
} from '../types/partnerTypes';
import { loadPartnersLayoutSaga } from './layoutSaga';

const getPartner = state => state.partner;
const getLayout = state => state.layout;

// L O A D   P A R T N E R S
function* loadPartnersSaga() {
    try {
        const partner = yield select(getPartner);

        const { offset, limit } = partner;

        const params = {
            offset,
            limit,
        };

        if (partner.sort !== null) {
            params.sort_by = JSON.stringify({ name: partner.sort.type === 'asc' ? 1 : -1 });
        } else {
            params.sort_by = JSON.stringify({ created_at: -1 });
        }

        if (partner.filters.name !== '') {
            params.filter = JSON.stringify({
                name: {
                    operator: 'typing',
                    value: partner.filters.name,
                },
            });
        }

        const result = yield getPartnersApi(params);
        yield put(loadPartnersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(loadPartnersErr());
    }
}

export function* loadPartnersWatcher() {
    yield takeLatest(LOAD_PARTNERS, loadPartnersSaga);
}
// L O A D   P A R T N E R S

// A D D   N E W   P A R T N E R
function* addPartnerHolidays(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'partner.notification.newPartnerAddedSuccess';

    try {
        const bulkParams = { bulk: action.data.holidays };
        const result = yield addNewPartnerHolidaysApi(bulkParams);

        if (result.status === 202) {
            yield put(addNewPartnerRes(true, false));
            yield put(push('/settings/partners/'));
            yield put(addNewPartnerRes(false, true));
            yield delay(1000);
            yield put(addNewPartnerRes(false, false));
            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(addNewPartnerErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'partner.notification.addingNewPartnerError');
        yield put(addNewPartnerErr());
    }
}
function* addNewPartnerSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'partner.notification.newPartnerAddedSuccess';

    try {
        const result = yield addNewPartnerApi(action.data);

        if (result.status === 202) {
            if (isEmpty(action.data.holidays)) {
                yield put(addNewPartnerRes(true, false));
                yield put(push('/settings/partners/'));
                yield put(addNewPartnerRes(false, true));
                yield delay(1000);
                yield put(addNewPartnerRes(false, false));
                yield delay(2000);
                yield call(loadPartnersLayoutSaga, {});
                setNotification('success', locale, 'global.success', finalDescription);
            } else {
                yield call(addPartnerHolidays, action);
            }
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(addNewPartnerErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'partner.notification.addingNewPartnerError');
        yield put(addNewPartnerErr());
    }
}

export function* addPartnerWatcher() {
    yield takeLatest(ADD_NEW_PARTNER, addNewPartnerSaga);
}
// A D D   N E W   P A R T N E R

// L O A D   E D I T A B L E   P A R T N E R S
function* loadEditablePartnerSaga(action) {
    try {
        const param = {
            filter: JSON.stringify({
                id: action.id,
            }),
        };

        const resultPartner = yield getPartnersApi(param);

        if (resultPartner.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Partner does not exist',
            });

            yield put(push('/404'));
            yield put(loadPartnersErr());
        } else {
            yield put(loadEditablePartnerRes(resultPartner.data.hits[0]));
        }
    } catch (e) {
        console.log(e);
        yield put(loadPartnersErr());
    }
}

export function* loadEditablePartnerWatcher() {
    yield takeLatest(LOAD_EDITABLE_PARTNER, loadEditablePartnerSaga);
}
// L O A D   E D I T A B L E   P A R T N E R S

// E D I T   P A R T N E R S
function* editPartnerHolidays(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const bulkParams = { bulk: action.data.holidays };
        const result = yield editPartnerHolidaysApi(bulkParams);

        if (result.status === 202) {
            yield put(push('/settings/partners/'));
            yield put(editPartnerRes(false, true));
            yield put(editPartnerRes(result));
            yield delay(1000);
            yield put(editPartnerRes(false, false));
            setNotification('success', locale, 'global.success', 'partner.notification.partnerEditedSuccess');
        } else {
            const text = yield result.text();
            let error;
            try {
                error = JSON.parse(text);
            } catch (parseError) {
                setNotification('error', locale, 'global.error', 'Erreur serveur : délai dépassé ou réponse invalide');
                yield put(editPartnerErr('Erreur serveur'));
                return;
            }

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(editPartnerErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'partner.notification.partnerEditedError');
        yield put(editPartnerErr());
    }
}

function* editPartnerSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    try {
        const result = yield editPartnerApi(action.data);

        if (result.status === 202) {
            yield put(editPartnerRes(true, false));
            yield call(editPartnerHolidays, action);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(editPartnerErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(editPartnerErr());
        setNotification('error', locale, 'global.error', 'partner.notification.partnerEditedError');
    }
}

export function* editPartnerWatcher() {
    yield takeLatest(EDIT_PARTNER, editPartnerSaga);
}
// E D I T   P A R T N E R S
